<template>
    <div class="transaction">
  
      <Header :mainHeader="true"/>
  
      <section id="transaction-products" style="padding: 10px 0px !important">
        <div class="containers">
          <h3>Purchase Management</h3>

          <table class="table table-bordered">
            <thead>
                <tr>
                    <th>No</th>
                    <th>Supplier Date</th>
                    <th>Supplier PIN</th>
                    <th>Supplier Name</th>
                    <th>Items</th>
                    <th>Amount</th>
                    <th>Action</th>
                    <!-- <th>Download Invoice</th> -->
                </tr>
            </thead>
            <tbody v-if="purchases?.length > 0">
                <tr v-for="(purchase,index) in purchases" v-bind:key="purchase.id">
                    <td>{{ index+1 }}</td>
                    <td>{{ purchase.salesDt }}</td>
                    <td>{{ purchase.spplrTin }}</td>
                    <td>{{ purchase.spplrNm }}</td>
                    <td>{{ purchase.totItemCnt }}</td>
                    <td>KES {{ formatToMoney(purchase.totAmt) }}</td>
                    <td>
                        <button v-if="isStringInArray(purchase.spplrInvcNo)" class="btn btn-warning btn-sm">Already Updated</button>  
                        <button v-else class="btn btn-primary btn-sm" style="margin-right: 10px;" @click="openModal(purchase)">Update Purchase</button>
                    </td>
                    <td>
                        <button class="btn btn-success btn-sm" @click="generatePurchaseInvoice(purchase)">Download Invoice</button>
                    </td>
                </tr>
                <!-- Add more rows as needed -->
            </tbody>
            <p v-else  style="color: red; padding: 20px; font-size: 21px;">No Purchases found</p>
        </table>
        </div>
        <div v-show="isVisible" class="modal">
            <div class="modal-content">
                <span class="close" style="position:absolute; width: fit-content; right: 0; margin-right: 20px;" @click="closeModal">&times;</span>
                <div class="row">
                    <div class="col-md-5">
                        <label for="">Select Purchase Progress Status</label>
                        <select v-model="status" class="form-control" style="width: 98%;" v-if="codes[13]">
                            <option v-for="(objItem) in codes[13].dtlList" v-bind:key="objItem.id" :value="objItem.cd">{{ objItem.cdNm }}</option>
                        </select>
                    </div>
                    <div class="col-md-7">
                        <label for="">Remarks</label>
                        <input type="text" v-model="remarks" class="form-control" />
                    </div>
                
                </div>
                <table class="table table-hover">
                    <thead><th>Purchase Item</th><th>Store Item</th></thead>
                    <tbody>
                        <tr v-for="(purchaseItem) in currentPurchase.itemList" v-bind:key="purchaseItem.itemSeq">
                            <td>
                                <p>Item Code: {{ purchaseItem.itemCd }}</p>
                                <p>Item Classification Code: {{ purchaseItem.itemClsCd }}</p>
                                <p>Item Name: {{ purchaseItem.itemNm }}</p>
                                <p>Price: {{ purchaseItem.prc }}</p>
                                <p>Qty: {{ purchaseItem.qty }}</p>
                                <p>Tax: {{ purchaseItem.taxAmt }}</p>
                                <p>Total: {{ purchaseItem.totAmt }}</p>
                            </td>
                            <td>
                                <label for="">Select Item</label>
                                <select v-model="item" style="width: 98%;" v-if="items" class="form-control">
                                    <option v-for="(objItem) in items" v-bind:key="objItem.id" :value="objItem">{{ objItem.itemNm }}</option>
                                </select>
                            </td>
                            <td>
                                <button class="btn btn-primary btn-sm" style="margin-top: 27px;" @click="confirmPurchase(purchaseItem)">Confirm</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="row">
                    <button class="btn-style col-md-5" style="float:right; margin: 20px;" @click="updatePurchase('NORMAL')">Update and Affect Stock Purchase</button>
                    <button class="btn-style col-md-5" style="float:right; margin: 20px;" @click="updatePurchaseService">Update Purchase Status Only</button>
                </div>
            </div>
        </div>
      </section>
    </div>
  </template>
  
<script>

import Header from '../../components/Header';
import Swal from 'sweetalert2'
import { toRaw } from 'vue'

export default {
name: 'PurchasePage',
components: {
    Header,
},
data(){
    return{
        token: JSON.parse(localStorage.getItem('access_token')),
        purchases: [],
        codes:[],
        items:[],
        isVisible:false,
        status: "",
        remarks: "",
        item:{},
        currentPurchase:{},
        itemList:[],
        updatedPurchases:[],

    }
},
methods:{
    openModal(obj){
        this.isVisible = true;
        this.currentPurchase = toRaw(obj);
    },
    closeModal() {
        this.isVisible = false;
    },
    formatToMoney(value) {
        const formattedValue = Number(value).toFixed(2);
        return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    confirmPurchase(obj){
        const pObj = toRaw(obj);
        const itemSeq = this.itemList.length + 1
        var newItem = {
            "itemSeq": itemSeq,
            "itemId":this.item.id,
            "itemCd": this.item.itemCd,
            "itemClsCd": this.item.itemClsCd,
            "itemNm": this.item.itemNm,
            "itemNmDef": this.item.itemCdDf,
            "bcd": pObj.bcd,
            "spplrItemClsCd": pObj.itemClsCd,
            "spplrItemCd": pObj.itemCd,
            "spplrItemNm": pObj.itemNm,
            "pkgUnitCd": pObj.pkgUnitCd,
            "pkg": pObj.pkg,
            "qtyUnitCd": pObj.qtyUnitCd,
            "qty": pObj.qty,
            "prc": pObj.prc,
            "splyAmt": pObj.splyAmt,
            "dcRt": pObj.dcRt,
            "dcAmt": pObj.dcAmt,
            "taxblAmt": pObj.taxblAmt,
            "taxTyCd": pObj.taxTyCd,
            "taxAmt": pObj.taxAmt,
            "totAmt": pObj.totAmt,
            "itemExprDt": null
        }
        this.itemList.push(newItem);
        this.item = {}
    },
    async updatePurchaseService(){
        this.itemList = [];
        this.currentPurchase.itemList.forEach(item => { 
            var newItem = {
                "itemSeq": item.itemSeq,
                "itemId":1,
                "itemCd": item.itemCd,
                "itemClsCd": item.itemClsCd,
                "itemNm": item.itemNm,
                "itemNmDef": item.itemNm,
                "bcd": item.bcd,
                "spplrItemClsCd": item.itemClsCd,
                "spplrItemCd": item.itemCd,
                "spplrItemNm": item.itemNm,
                "pkgUnitCd": item.pkgUnitCd,
                "pkg": item.pkg,
                "qtyUnitCd": item.qtyUnitCd,
                "qty": item.qty,
                "prc": item.prc,
                "splyAmt": item.splyAmt,
                "dcRt": item.dcRt,
                "dcAmt": item.dcAmt,
                "taxblAmt": item.taxblAmt,
                "taxTyCd": item.taxTyCd,
                "taxAmt": item.taxAmt,
                "totAmt": item.totAmt,
                "itemExprDt": null
            }
            this.itemList.push(newItem);            
        });
        await this.updatePurchase("PURCHASE");
    },
    async updatePurchase (type) {
        const dateTimeNow = this.getCurrentDateTimeFormatted()
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            body: JSON.stringify({ 
                "invcNo": 1,
                "orgInvcNo": 0,
                "spplrTin": this.currentPurchase.spplrTin,
                "spplrBhfId": this.currentPurchase.spplrBhfId,
                "spplrNm": this.currentPurchase.spplrNm,
                "spplrInvcNo": this.currentPurchase.spplrInvcNo,
                "regTyCd": "M",
                "pchsTyCd": "N",
                "rcptTyCd": "P",
                "type": type,
                "pmtTyCd": this.currentPurchase.pmtTyCd,
                "pchsSttsCd": this.status,
                "cfmDt": dateTimeNow,
                "pchsDt": this.currentPurchase.salesDt,
                "wrhsDt": "",
                "cnclReqDt": "",
                "cnclDt": "",
                "rfdDt": "",
                "totItemCnt": this.itemList.length,
                "taxblAmtA": this.currentPurchase.taxblAmtA,
                "taxblAmtB": this.currentPurchase.taxblAmtB,
                "taxblAmtC": this.currentPurchase.taxblAmtC,
                "taxblAmtD": this.currentPurchase.taxblAmtD,
                "taxblAmtE": this.currentPurchase.taxblAmtE,
                "taxRtA": this.currentPurchase.taxRtA,
                "taxRtB": this.currentPurchase.taxRtB,
                "taxRtC": this.currentPurchase.taxRtC,
                "taxRtD": this.currentPurchase.taxRtD,
                "taxRtE": this.currentPurchase.taxRtE,
                "taxAmtA": this.currentPurchase.taxAmtA,
                "taxAmtB": this.currentPurchase.taxAmtB,
                "taxAmtC": this.currentPurchase.taxAmtC,
                "taxAmtD": this.currentPurchase.taxAmtD,
                "taxAmtE": this.currentPurchase.taxAmtE,
                "totTaxblAmt": this.currentPurchase.totTaxblAmt,
                "totTaxAmt": this.currentPurchase.totTaxAmt,
                "totAmt": this.currentPurchase.totAmt,
                "remark": this.remarks,
                "regrNm": "Admin",
                "regrId": "Admin",
                "modrNm": "Admin",
                "modrId": "Admin",
                "itemList": this.itemList
            })
        };
        const res = await fetch(process.env.VUE_APP_URL+'/purchases/updated', requestOptions)
        const data = await res.json()
        if(data.status == true){
            Swal.fire({
                icon: 'success',
                title: 'purchases updated successfully',
                text: data.message
            })
            console.log(data)
        }else{
            Swal.fire({
                icon: 'error',
                title: 'purchases not found',
                text: data.message
            })
        }
    },
    async getPurchases () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/purchases/updated', requestOptions)
        const data = await res.json()
        if(data.status == true){
            this.purchases = data.purchases
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Purchase not found',
                text: data.message
            })
        }
    },
    async getUpdatePurchases () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/purchases/', requestOptions)
        const data = await res.json()
        console.log(data)
        this.updatedPurchases = data.purchases
    },
    isStringInArray(task) {
        return this.updatedPurchases.some(obj => obj.spplrInvcNo==task );
    },
    async getCodes () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/items/pullcodes', requestOptions)
        const data = await res.json()
        this.codes = data.kraResult.clsList;
    },
    async getItems () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/items', requestOptions)
        const data = await res.json()
        if(data.status == true){
            this.items = data.items
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Items not found',
                text: data.message
            })
        }
    },
    roundToTwo(num) {
      return parseFloat(num.toFixed(2));
    },
    getCurrentDateFormatted() {
      const now = new Date();

      const year = now.getFullYear();
      // Get month, add 1 as getMonth() returns 0-11, and pad with zero if necessary
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');

      return `${year}${month}${day}`;
    },
    getCurrentDateTimeFormatted() {
      const now = new Date();

      const year = now.getFullYear();
      // Get month, add 1 as getMonth() returns 0-11, and pad with zero if necessary
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');

      return `${year}${month}${day}${hours}${minutes}${seconds}`;
    },
    async generatePurchaseInvoice(purchase) {
        // Build invoice data from purchase row, hardcode items as in SalesPage
        const data = {
            invoiceNumber: purchase.invcNo,
            billNo: purchase.invcNo,
            date: this.formatPurchaseDateTime(purchase.cfmDt),
            printDate: this.formatPurchaseDateTime(purchase.cfmDt),
            shopName: "GA INSURANCE LIMITED",
            phone: '0709626000', // Add if available
            pin: "P000612829R",
            email: 'insure@gakenya.com', // Add if available
            customer: '', // Add if available
            customerTin: '', // Add if available
            customerInvoice: purchase.spplrInvcNo,
            scuId: "KRACU0300000142",
            total: purchase.totAmt,
            spplrNm: purchase.spplrNm,
            spplrTin: purchase.spplrTin,
            items: [
                {
                    name: 'Medical Claims Oct 2025',
                    qty: 1,
                    price: Number(purchase.totAmt),
                    amount: Number(purchase.totAmt)
                }
            ],
            qrData: `Invoice No: ${purchase.invcNo}, PIN: ${purchase.spplrTin}, Amount: ${purchase.totAmt}`,
            preparedBy: 'System'
        };
        const html = await this.createPurchaseInvoice(data);
        this.downloadInvoice(html, `purchase_invoice_${purchase.spplrNm.replace(/\s+/g, '_')}_${purchase.invcNo}.html`);
    },
    async createPurchaseInvoice(data) {
        const totalAmount = Number(data.total) || 0;
        const qrCodeDataUrl = await this.generateQRCode(data.qrData);
        // Format total and balance with commas
        const formattedTotal = this.formatToMoney(totalAmount);
        return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <title>Invoice ${data.invoiceNumber}</title>
            <style>
                * { margin: 0; padding: 0; box-sizing: border-box; }
                @media print {
                    body { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                    @page { size: A4; margin: 15mm; }
                }
                body { font-family: Arial, sans-serif; line-height: 1.3; color: #000; background: #fff; }
                .invoice-container { width: 210mm; min-height: 297mm; padding: 20mm; margin: 0 auto; background: white; }
                .invoice-header { background-color: #87CEEB !important; color: black; text-align: center; padding: 10px; margin-bottom: 20px; font-weight: bold; font-size: 18px; border-radius: 4px; }
                .info-section { display: flex; justify-content: space-between; gap: 20px; margin-bottom: 20px; }
                .info-box { flex: 1; border: 1px solid black; padding: 15px; border-radius: 4px; }
                .info-box p { margin: 5px 0; font-size: 12px; line-height: 1.4; }
                .details-section { border: 1px solid black; padding: 15px; margin-bottom: 20px; border-radius: 4px; }
                .details-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
                .details-grid p { margin: 5px 0; font-size: 12px; }
                .items-table { width: 100%; border-collapse: collapse; margin: 20px 0; page-break-inside: auto; }
                .items-table tr { page-break-inside: avoid; page-break-after: auto; }
                .items-table th, .items-table td { border: 1px solid black; padding: 8px; text-align: left; font-size: 12px; }
                .items-table th { background-color: #ffffff; font-weight: bold; }
                .totals-section { text-align: right; margin-top: 20px; page-break-inside: avoid; }
                .totals-section p { margin: 5px 0; font-size: 12px; }
                .signature-section { display: flex; justify-content: space-between; margin-top: 40px; page-break-inside: avoid; }
                .signature-box { width: 45%; }
                .signature-box p { font-size: 12px; margin-bottom: 5px; }
                .signature-line { border-top: 1px solid black; width: 80%; margin-top: 40px; }
                .page-break { page-break-after: always; }
                .no-break { page-break-inside: avoid; }
                .qr-section { display: flex; align-items: flex-start; justify-content: flex-start; margin: 20px 0; padding: 15px; border: 1px solid black; border-radius: 4px; page-break-inside: avoid; }
                .qr-code-container { display: flex; flex-direction: column; align-items: center; margin-right: 20px; }
                .qr-section img { width: 100px; height: 100px; border: 1px solid #ddd; padding: 5px; }
                .qr-details { flex: 1; }
                .qr-details p { margin: 5px 0; font-size: 12px; line-height: 1.4; }
                .qr-details strong { font-weight: bold; }
                .etims-footer { margin-top: 15px; padding-top: 8px; border-top: 1px solid #ddd; text-align: center; font-size: 11px; color: #666; font-style: italic; }
            </style>
        </head>
        <body>
            <div class="invoice-container">
                <div class="invoice-header">Purchase Invoice</div>
                <div class="info-section">  
                    <div class="info-box">
                        <p><strong>${data.shopName}</strong></p>
                        <p>Phone: ${data.phone}</p>
                        <p>Pin: ${data.pin}</p>
                        <p>Email: ${data.email}</p>
                    </div>
                    <div class="info-box">
                        <p><strong>Supplier Name:</strong> ${data.spplrNm}</p>
                        <p><strong>Supplier Pin:</strong> ${data.spplrTin}</p>
                        <p><strong>Supplier Invoice:</strong> ${data.customerInvoice}</p>
                    </div>
                </div>
                <div class="details-section">
                    <div class="details-grid">
                        <p><strong>Invoice No:</strong> ${data.invoiceNumber}</p>
                        <p><strong>Bill No:</strong> ${data.billNo}</p>
                        <p><strong>Created On:</strong> ${data.date}</p>
                        <p><strong>Due Date:</strong> ${data.printDate}</p>
                    </div>
                </div>
                <table class="items-table">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Rate</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${data.items.map((item, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${item.name}</td>
                                <td>${item.qty}</td>
                                <td>${this.formatToMoney(item.price)}</td>
                                <td>${this.formatToMoney(item.amount)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
                <div class="totals-section">
                    <p><strong>Total:</strong> ${formattedTotal}</p>
                    <p><strong>Balance:</strong> ${formattedTotal}</p>
                </div>
                <div class="qr-section">
                    <div class="qr-code-container">
                        <img src="${qrCodeDataUrl}" alt="QR Code"/>
                    </div>
                    <div class="qr-details">
                        <p><strong>SCU ID:</strong> ${data.scuId}</p>
                        <p><strong>SCU Invoice No:</strong> ${data.scuId}/${data.invoiceNumber}</p>
                    </div>
                </div>
                <div class="signature-section">
                    <div class="signature-box">
                        <p>Prepared by: ${data.preparedBy}</p>
                        <div class="signature-line"></div>
                    </div>
                    <div class="signature-box">
                        <p>Customer</p>
                        <div class="signature-line"></div>
                    </div>
                </div>
                <p class="etims-footer">eTIMS Invoice generated by Stanbest Group EA LTD</p>
            </div>
        </body>
        </html>`;
    },
    async generateQRCode(text) {
        // Use a public QR code API for simplicity
        const url = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(text)}&size=100x100`;
        return url;
    },
    downloadInvoice(html, filename) {
        const blob = new Blob([html], { type: 'text/html' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    formatPurchaseDateTime(dt) {
        if (!dt) return '';
        // dt is like '20250626225254' => '26/06/2025 - 22:52'
        const year = dt.substring(0,4);
        const month = dt.substring(4,6);
        const day = dt.substring(6,8);
        const hour = dt.substring(8,10);
        const min = dt.substring(10,12);
        // const sec = dt.substring(12,14);
        return `${day}/${month}/${year} - ${hour}:${min}`;
    }
},
mounted(){
    this.getPurchases()
    this.getCodes()
    this.getItems()
    this.getUpdatePurchases()
}
}
</script>


<style scoped>
.modal {
  display: block; 
  position: fixed; 
  z-index: 1; 
  padding-top: 100px; 
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto; 
  background-color: rgb(0,0,0); 
  background-color: rgba(0,0,0,0.4); 
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>